import { h, Component } from 'preact'
import Headline from '../components/Headline'
import Panel from '../components/Panel'
import ColorPicker from '../components/ColorPicker'
import Product from '../components/Product'
import Button from '../components/Button'
import { Text } from 'preact-i18n'
import Hints from '../components/Hints'

export default class ChooseColor extends Component {
    constructor(props) {
        super(props)

        this.state = {
            currentTab: 0
        }
    
        this.selectTab = currentTab => this.setState({currentTab})
    
        this.selectShade = shade =>
            this.props.setState({shade})
    
        this.selectCable = cable =>
            this.props.setState({cable})
    
        this.editCable = () => 
            this.setState({currentTab: 1})
    
        this.editShade = () => 
            this.setState({currentTab: 0})
    }

    render ({state: { cable, shade }, goto}, { currentTab }, {config: { options: { shade: shades = [], cable: cables }, colors}}) {
        return (
            <div class="limba__choose-color container" key="container">
                <Product shade={shade} cable={cable} editShade={this.editShade} editCable={this.editCable} />
                <div class="limba__controls" key="controls">
                    <Headline />
                    <Panel key="colorOptions" selected={currentTab} onChange={this.selectTab} key="controlpanel">
                        <Panel.Tab heading="parts.shade">
                            <ColorPicker 
                                title="labels.colorsBasic"
                                options={shades.filter(x => x.basic == 1)} 
                                selected={shade} 
                                textDomain={"shade.color"}
                                onChange={this.selectShade} 
                            />
                            <ColorPicker 
                                title="labels.colorsExtra"
                                options={shades.filter(x => x.basic == 0)} 
                                selected={shade}
                                textDomain={"shade.color"}
                                onChange={this.selectShade}
                            />
                        </Panel.Tab>
                        <Panel.Tab heading="parts.cable">
                            <ColorPicker 
                                title="labels.unicolor"
                                options={cables.filter(x => x.basic == 1)} 
                                selected={cable}
                                textDomain={"cable.color"}
                                onChange={this.selectCable}
                            />
                            <ColorPicker 
                                title="labels.pattern"
                                options={cables.filter(x => x.basic == 0)} 
                                selected={cable}
                                textDomain={"cable.color"}
                                onChange={this.selectCable}
                            />
                        </Panel.Tab>
                    </Panel>
                    <div class="limba__controls-next"><Button onClick={() => goto('chooseMount')}><Text id="controls.next" /><span class="konf-icon-Arrow-OutRight"></span></Button></div>
                </div>
                <Hints />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./js/views/ChooseColor.js